window.addEventListener('load', event => {
    const wilderPage = document.querySelector('.page-pagewilder');
    if (wilderPage) {
        document.documentElement.classList.add('overscroll-y-none','wilder');
        const scrollContainer = document.querySelector('[data-scroll-container]');

        // Get the currently active content section
        let activeContentSection = scrollContainer.dataset.contentActive;

        // Create a variable to lock the function
        let isLocked = false;

        // Track touch start position
        let touchStartY = 0;

        const scrollFunction = (direction) => {

            // Check if function is locked before proceeding
            if (isLocked) {
                return;
            }

            // Lock the function to prevent firing while transitions undergoing
            isLocked = true;

            if (activeContentSection) {
                const scrollChange = direction === 'down' ? 1 : -1;
                const nextContentValue = parseInt(activeContentSection) + scrollChange;

                // Find the next or previous content section based on the data-wilder-content value
                const nextContentSection = document.querySelector(`[data-wilder-content="${nextContentValue}"]`);

                // if exists update scroll containers active content section value
                if (nextContentSection) {
                    activeContentSection = nextContentValue;
                    scrollContainer.dataset.contentActive = nextContentValue;
                }
            }

            // unlock after 1 second (transitions are 1second)
            setTimeout(() => {
                isLocked = false;
            }, 1000);
        };

        // Handle scrolling with scroll wheel
        const throttleScrollFunction = _throttle((event) => {
            event.preventDefault();
            scrollFunction(event.deltaY > 0 ? 'down' : 'up');
        }, 100);

        scrollContainer.addEventListener('wheel', throttleScrollFunction);

        // Handle swipe gestures on touch devices
        scrollContainer.addEventListener('touchstart', (event) => {
            touchStartY = event.touches[0].clientY;
        });

        scrollContainer.addEventListener('touchend', (event) => {
            const touchEndY = event.changedTouches[0].clientY;
            // swipe threshold in px
            const swipeThreshold = 30;
            const swipeDirection = touchEndY > touchStartY + swipeThreshold ? 'up' : touchEndY < touchStartY - swipeThreshold ? 'down' : '';

            if (swipeDirection) {
                scrollFunction(swipeDirection);
            }
        });

    }
});
